import { backendRequest } from 'services/request'

export function requestUploadTask(data) {
  return backendRequest({
    url: '/upload/',
    method: 'post',
    data
  })
}


export function autoIngest(data) {
  return backendRequest({
    url: '/upload/auto-ingest',
    method: 'post',
    data: {
      files: data
    }
  })
}